// Generated by CoffeeScript 1.12.4
module.exports = {
  tokenIdentifyErrorPrefix: 'Must have an active token from'
};
